import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getTemplateList, templateUseForEnvelope } from "../../services/Templates";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { getTemplateDocumentData } from "../../services/CommonService";

function UseTemplate(props) {
    const [loading, setLoading] = useState(false);
    let buttonList = [
        { id: 1, name: 'My Templates', icon: 'bi-folder-fill', active: true },
        { id: 2, name: 'Shared with me', icon: 'bi-person', active: false },
        { id: 3, name: 'DocuSafe Templates', icon: 'bi-file-earmark-text', active: false }
    ];
    const [buttons, setButtons] = useState(buttonList);
    const [isBack, setIsBack] = useState(-1);
    const [templateList, setTemplateList] = useState([]);
    const [breadcrumbs, setBreadcrumbs] = useState([]);
    const [useTemplateId, setUseTemplateId] = useState(0);
    const [selectedTemplateList, setSelectedTemplateList] = useState([]);

    const navigate = useNavigate();

    let currentTemplateObj = {
        tab_id: 1,
        current_tab: "My Templates",
        current_folder: 0,
        is_refresh: false
    };
    const [currentTemplate, setCurrentTemplate] = useState(currentTemplateObj);

    const clsUseTemplateRef = useRef(null);

    // Get the icon for the current tab
    const currentTabIcon = buttons.find(btn => btn.name === currentTemplate.current_tab)?.icon || "bi-folder-fill";

    useEffect(function () {
        if (props.isUseTemplate) {
            setLoading(true);
            let obj = {
                template: currentTemplate.tab_id,
                folder_id: currentTemplate.current_folder
            };
            getTemplateList(obj)
                .then(response => {
                    // setUseTemplateId(0);
                    //Need to already selected templates
                    if (selectedTemplateList.length > 0) {
                        for (let i = 0; i < response.data.data.length; i++) {
                            if (response.data.data[i].entity_type === 2) {
                                let templateEntityId = response.data.data[i].entity_id;
                                let templateAlreadySelected = selectedTemplateList.findIndex(item => item.id === templateEntityId);
                                if (templateAlreadySelected !== -1) {
                                    response.data.data[i]['active'] = true;
                                    response.data.data[i]['is_checked'] = true;
                                } else {
                                    response.data.data[i]['active'] = false;
                                    response.data.data[i]['is_checked'] = false;
                                }
                            }
                        }
                    }
                    setTemplateList(response.data.data);

                    setBreadcrumbs(response.data.breadcrumbs);
                    setIsBack(response.data.back_id);
                    setLoading(false);
                })
                .catch(err => {
                    setLoading(false);
                    toast.error(Utils.getErrorMessage(err));
                });
        }
    }, [props, currentTemplate, selectedTemplateList]);

    const handleTemplateButton = (e, data) => {
        e.preventDefault();
        let button = [...buttonList];
        let currentTem = { ...currentTemplate };
        for (let i = 0; i < button.length; i++) {
            let active = false;
            if (button[i]['id'] === data.id) {
                active = true;
                currentTem.tab_id = data.id;
                currentTem.current_tab = button[i]['name'];
                currentTem.current_folder = 0;
            }
            button[i]['active'] = active;
        }
        setButtons(button);
        setCurrentTemplate(currentTem);
    };

    const onClickFolder = (e, id) => {
        let currentTem = { ...currentTemplate };
        currentTem.current_folder = parseInt(id);
        setCurrentTemplate(currentTem);
    };

    const handleBack = (e) => {
        e.preventDefault();
        let template = { ...currentTemplate };
        template.current_folder = isBack;
        setCurrentTemplate(template);
    };

    const handleCloseUseTemplate = (e) => {
        e.preventDefault();
        props.setIsUseTemplate(false);
        setIsBack(-1);
        setTemplateList([]);
        setBreadcrumbs([]);
        setButtons(buttonList);
        setCurrentTemplate(currentTemplateObj);
        setSelectedTemplateList([]);
    };

    const onSelectTemplate = (e, data, index) => {
        e.preventDefault();

        let templateEntityId = data.entity_id;
        let templateAlreadySelected = selectedTemplateList.findIndex(item => item.id === templateEntityId);
        if (templateAlreadySelected !== -1) {
            toast.error("Template has been already selected.");
            return false;
        }

        setLoading(true);
        let tempList = [...selectedTemplateList];
        let obj = {
            template_id: data.entity_id
        };
        getTemplateDocumentData(obj)
            .then(response => {
                let idx = tempList.findIndex((x) => parseInt(x.id) === parseInt(data.entity_id));
                let newList = [];
                for (let i = 0; i < response.data.data.length; i++) {
                    response.data.data[i].active = true;
                    newList.push(response.data.data[i]);
                }
                if (idx > -1) {
                    tempList[idx]['list'] = newList;
                } else {
                    tempList.push({
                        id: data.entity_id,
                        name: data.template_name,
                        is_checked: true,
                        list: newList
                    })
                }
                setSelectedTemplateList(tempList);

                let list = [...templateList];
                list[index]['active'] = true;
                list[index]['is_checked'] = true;

                setTemplateList(list);
                setUseTemplateId(parseInt(templateEntityId));
                setLoading(false);
            })
            .catch(err => {
                toast.error(Utils.getErrorMessage(err));
                setLoading(false);
            });
    };

    const handleCreateEnvelope = (e) => {
        e.preventDefault();
        if (useTemplateId > 0) {
            if (selectedTemplateList.length > 0) {
                setLoading(true);

                let docIds = [];
                let dataIds = [];
                for (let i = 0; i < selectedTemplateList.length; i++) {
                    for (let j = 0; j < selectedTemplateList[i]['list'].length; j++) {
                        if (selectedTemplateList[i]['list'][j]['active']) {
                            if (parseInt(selectedTemplateList[i]['list'][j]['entity_type']) === 1) {
                                docIds.push(parseInt(selectedTemplateList[i]['list'][j]['id']));
                            } else if (parseInt(selectedTemplateList[i]['list'][j]['entity_type']) === 2) {
                                dataIds.push(parseInt(selectedTemplateList[i]['list'][j]['id']));
                            }
                        }
                    }
                }
                if (docIds.length > 0 || dataIds.length > 0) {
                    let obj = {
                        id: useTemplateId,
                        doc_ids: docIds,
                        data_ids: dataIds
                    };
                    templateUseForEnvelope(obj)
                        .then(response => {
                            clsUseTemplateRef?.current.click();
                            setLoading(false);
                            navigate("/client-portal/sleeve/edit/" + response.data.uuid + "/4/direct");
                        })
                        .catch(err => {
                            setLoading(false);
                            toast.error(Utils.getErrorMessage(err));
                        });
                } else {
                    setLoading(false);
                    toast.error('Please select any template');
                }
            } else {
                toast.error('Please select template');
            }
        } else {
            toast.error('Please select any template');
        }
    };

    const handleSelectTemplate = (e, index, idx) => {
        let tempList = [...selectedTemplateList];
        if (tempList[index]['list'][idx].active) {
            tempList[index]['list'][idx].active = false;
        } else {
            tempList[index]['list'][idx].active = true;
        }
        setSelectedTemplateList(tempList);
    };

    const handleChooseTemplate = (e, index) => {
        let tempList = [...selectedTemplateList];
        for (let i = 0; i < tempList.length; i++) {
            tempList[i]['is_checked'] = false;
            if (i === index) {
                setUseTemplateId(parseInt(tempList[i]['id']));
                tempList[i]['is_checked'] = true;
            }
        }
        setSelectedTemplateList(tempList);
    };

    const removeTemplate = (item, index) => {
        setSelectedTemplateList((prevList) =>
            prevList.filter((_, i) => i !== index)
        );

        let tempList = [...selectedTemplateList];
        tempList.splice(index, 1); // Remove the item at the given index
        if (tempList.length > 0) {
            setUseTemplateId(parseInt(tempList[tempList.length - 1]['id']));
        } else {
            setUseTemplateId(0);
        }
    }

    return (
        <>
            {loading && <div className="page-loading">
                <img src="/images/loader.gif" alt="loader" />
            </div>}

            <div className="offcanvas offcanvas-end AddDocument AddTemplate templates_page makeFillableForm" id="useTemplate"
                data-bs-backdrop="static" data-bs-keyboard="true">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="MakeFormLabel">Add From Templates</h5>
                    <button type="button" className="btn btn-close close_btn text-reset " data-bs-dismiss="offcanvas"
                        ref={clsUseTemplateRef} onClick={handleCloseUseTemplate} aria-label="Close">
                        <i className="bi bi-x-circle" aria-hidden="true" />
                    </button>
                </div>
                <div className="offcanvas-body p-0 document_form_wrap overflow-x-hidden">
                    <div className="row border_radius mx-0">
                        <div className="col-lg-2 border_right border-right-template bg-light p-3 tempalte_lestside"  >
                            <div className="nav nav-tabs flex-column" id="nav-tab" role="tablist">
                                {buttons.map((item, index) =>
                                    <button key={index} onClick={(e) => handleTemplateButton(e, item)}
                                        className={`nav-link ${item.active ? `active` : ``}`}>
                                        <i className={`me-1 bi ${item.icon}`} aria-hidden={item.active} /> {item.name}
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className={`${selectedTemplateList.length > 0 ? `col-lg-7` : `col-lg-10`} px-0`}>
                            <div className="tab-content tab-content-height" id="nav-tabContent" >
                                <div className="tab-pane fade active show" id="MyTemplates-detail" role="tabpanel"
                                    aria-labelledby="MyTemplatesDetails">
                                    <h2 className="d-flex align-items-center justify-content-between bread_crumb bg-light text-dark flexWrap px-3 p-3 mt">
                                        <span>
                                            {breadcrumbs.length > 0 ?
                                                <>
                                                    <span className="text_blue cur-pointer"
                                                        onClick={(e) => onClickFolder(e, 0)}><i className={`bi ${currentTabIcon}`}
                                                            aria-hidden="true" /> {currentTemplate.current_tab}</span>
                                                    {breadcrumbs.map((breadcrumb, b) =>
                                                        <React.Fragment key={b}>
                                                            <i className="bi bi-chevron-double-right mx-3" />
                                                            {breadcrumb.is_last === true ?
                                                                <span><i className="bi bi-folder-fill"
                                                                    aria-hidden="true" /> {breadcrumb.folder_name}</span>
                                                                :
                                                                <span className="text_blue cur-pointer"
                                                                    onClick={(e) => onClickFolder(e, breadcrumb.id)}><i
                                                                        className="bi bi-folder-fill"
                                                                        aria-hidden="true" /> {breadcrumb.folder_name}</span>
                                                            }
                                                        </React.Fragment>
                                                    )}
                                                </>
                                                :
                                                <span><i className={`bi ${currentTabIcon} me-1`}
                                                    aria-hidden="true" />{currentTemplate.current_tab}</span>
                                            }
                                        </span>
                                        <div className="d-flex">
                                            {isBack > -1 &&
                                                <button type="button" onClick={handleBack}
                                                    className="btn modern-back-btn">
                                                    <i className="bi bi-arrow-left me-2" aria-hidden="true" />Back
                                                </button>
                                            }
                                        </div>
                                    </h2>
                                    <div className="template-list">
                                        {templateList && templateList.length > 0 ? (
                                            templateList.map((item, index) =>
                                                item.entity_type === 1 ? (
                                                    // Folder UI
                                                    <div
                                                        key={index}
                                                        className="template-folder-item d-flex align-items-center p-3 mb-2 cur-pointer folder-hover"
                                                        onClick={(e) => onClickFolder(e, item.entity_id)}
                                                    >
                                                        <i className="bi bi-folder-fill folder-icon me-3" />
                                                        <span className="folder-name">{item.template_name}</span>
                                                    </div>
                                                ) : (
                                                    // Template UI
                                                    <div
                                                        key={index}
                                                        className={`template-template-item d-flex align-items-center justify-content-between p-3 mb-2 cur-pointer template-hover ${item.active ? "active" : ""}`}
                                                        onClick={(e) => onSelectTemplate(e, item, index)}
                                                    >
                                                        <div className="d-flex align-items-center">
                                                            <i className="bi bi-file-earmark-text template-icon me-3" />
                                                            <div>
                                                                <span className="template-name fw-bold">{item.template_name}</span>
                                                                <div className="template-meta small text-muted">
                                                                    <span className="me-3"><i className="bi bi-person" /> {item.sender_name}</span>
                                                                    <div className="calendar-date-center">
                                                                        <svg
                                                                            className="custom-calendar-icon"
                                                                            width="22"
                                                                            height="22"
                                                                            viewBox="0 0 22 22"
                                                                            fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <rect x="3" y="5" width="16" height="14" rx="2" fill="none" stroke="#8B94A7" strokeWidth="1.5" />
                                                                            <rect x="3" y="8" width="16" height="2" fill="#8B94A7" opacity="0.15" />
                                                                            <rect x="7" y="12" width="2" height="2" rx="1" fill="#8B94A7" />
                                                                            <rect x="11" y="12" width="2" height="2" rx="1" fill="#8B94A7" />
                                                                            <rect x="15" y="12" width="2" height="2" rx="1" fill="#8B94A7" />
                                                                            <rect x="7" y="16" width="2" height="2" rx="1" fill="#8B94A7" />
                                                                            <rect x="11" y="16" width="2" height="2" rx="1" fill="#8B94A7" />
                                                                            <rect x="15" y="16" width="2" height="2" rx="1" fill="#8B94A7" />
                                                                            <rect x="7" y="2" width="2" height="4" rx="1" fill="#8B94A7" />
                                                                            <rect x="13" y="2" width="2" height="4" rx="1" fill="#8B94A7" />
                                                                        </svg>
                                                                        <span className="calendar-date-text">{item.created_at}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <span className={`select-icon ms-3 ${item.active ? "bg-success text-white" : ""}`}>
                                                            <i className={`bi ${item.active ? "bi-check" : "bi-plus"}`} />
                                                        </span>
                                                    </div>
                                                )
                                            )
                                        ) : (
                                            <div className="empty-folder-message text-center py-5">
                                                <i className="bi bi-file-earmark-text empty-doc-icon mb-3"></i>
                                                <div className="empty-message-title">No templates or folders available</div>
                                                <div className="empty-message-subtext">
                                                    You don’t have any templates or folders here yet.
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {selectedTemplateList.length > 0 &&
                            <div className="col-lg-3 px-0">
                                <h2 className="sub_main_title d-flex align-items-center justify-content-center bread_crumb flexWrap p-3 bg_blue text_blue border-bottom mb-0">Selected Templates</h2>
                                <div className="bg-blue p-3 selected-template-list-height">
                                    {selectedTemplateList.map((item, index) =>
                                        <div key={index} className="accordion cu-position-relative mb-4" id={`accordion_${index}`}>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id={`heading_${index}`}>
                                                    <button className="accordion-button rubik-semi-bold" type="button"
                                                        data-bs-toggle="collapse" data-bs-target={`#collapse_${index}`}
                                                        aria-expanded="true" aria-controls={`collapse_${index}`}>
                                                        <input type="radio" className="me-2 d-none" data-bs-toggle="collapse"
                                                            checked={item.is_checked}
                                                            onChange={(e) => handleChooseTemplate(e, index)} />
                                                        {item.name}
                                                    </button>
                                                </h2>
                                                <div id={`collapse_${index}`} className="accordion-collapse collapse show"
                                                    aria-labelledby={`heading_${index}`}
                                                    data-bs-parent={`#accordion_${index}`}>
                                                    <div className="accordion-body px-0">
                                                        {item.list.map((data, idx) =>
                                                            <h2 key={idx}
                                                                className="request_document_tab cur-pointer mb-3 bg_white position-relative"
                                                                onClick={(e) => handleSelectTemplate(e, index, idx)}>
                                                                <div
                                                                    className="d-flex justify-content-between flex_wrap align-items-center">
                                                                    <div className="accordion_text">
                                                                        <i className={`bi ${data.active ? `bi-check-square-fill` : `bi-square`} me-2`}
                                                                            aria-hidden="true" />
                                                                        {data.name}
                                                                    </div>
                                                                </div>
                                                            </h2>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="remove-template" onClick={() => removeTemplate(item, index)}>
                                                <img style={{ width: "30px", height: "30px" }} src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Ebene_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='595.275px' height='595.275px' viewBox='200 215 230 470' xml:space='preserve'%3E%3Ccircle style='fill:%23F44336;' cx='299.76' cy='439.067' r='218.516'/%3E%3Cg%3E%3Crect x='267.162' y='307.978' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -222.6202 340.6915)' style='fill:white;' width='65.545' height='262.18'/%3E%3Crect x='266.988' y='308.153' transform='matrix(0.7071 0.7071 -0.7071 0.7071 398.3889 -83.3116)' style='fill:white;' width='65.544' height='262.179'/%3E%3C/g%3E%3C/svg%3E" alt="delete" />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        }
                    </div>
                    <div className="modal-footer py-2 border-2 border-top">
                        <button
                            type="button"
                            onClick={handleCloseUseTemplate}
                            className="btn modern-cancel-btn"
                            data-bs-dismiss="offcanvas"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={handleCreateEnvelope}
                            className="btn sleeve-btn-next border-0 text-white"
                        >
                            <i className="bi bi-plus-circle me-2"></i>
                            Create Sleeve
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UseTemplate;